<template>
    <span>
        <div v-if="errors.length" class="text-danger">
            <small class="font-weight-bold">
                {{ errors[0] }}
            </small>
        </div>
    </span>
</template>

<script>
export default {
    props: {
        errors: {
            type: Array,
            default: () => [],
        },
    }
}
</script>

<style>

</style>
